module.exports = __webpack_public_path__ + "img/tophjwl_bg.0d8c986b.png";